import React from 'react';
import { Col, Form, Row, Typography, Upload } from 'antd';
import { useTranslation } from 'react-i18next';
import { InboxOutlined } from '@ant-design/icons';

const FileSection = () => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Allegato')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item
          name='type'
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Upload.Dragger name='files' action='/upload.do'>
            <p className='ant-upload-drag-icon'>
              <InboxOutlined />
            </p>
            <p className='ant-upload-text'>
              {t('Click or drag file to this area to upload')}
            </p>
          </Upload.Dragger>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(FileSection);
